import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { ClubTag, ClubTagPaginationFilterRequest, UpsertClubTag } from '@/models/club-tag.model';

export const getPagedClubTags = async (input: ClubTagPaginationFilterRequest): Promise<PagedResponseModel<ClubTag>> => {
  return await getReq(createUrl("a/RunningClub/Tag/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

/** The whole tag vocabulary (it is small), for pickers. */
export const getAllClubTags = async (): Promise<ClubTag[]> => {
  return await getPagedClubTags({ pageNumber: 1, pageSize: 100, isAscending: true, orderBy: 'Type' })
    .then(data => data.result);
};

export const getClubTag = async (id: number): Promise<BaseResponseModel<ClubTag>> => {
  return await getReq(createUrl(`a/RunningClub/Tag/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertClubTag = async (input: UpsertClubTag): Promise<BaseResponseModel<ClubTag>> => {
  return await postReq(createUrl("a/RunningClub/Tag/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteClubTag = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/RunningClub/Tag/Delete/${id}`),
  ).then((res: any) => res.data);
};
